// src/pages/admin/services/userService.js
import {
  getFirestore,
  collection,
  getDocs,
  query,
  orderBy
} from 'firebase/firestore';

/**
 * Fetch all users and categorize them.
 * @returns {Promise<{ allUsers, unassignedMentors, unassignedLearners }>}
 */
export const fetchUsers = async () => {
  try {
    const db = getFirestore();
    const snapshot = await getDocs(
      query(collection(db, "users"), orderBy("name"))
    );

    const allUsers = [];
    const unassignedMentors = [];
    const unassignedLearners = [];

    snapshot.forEach(doc => {
      const raw = doc.data();
      const user = {
        id: doc.id,
        name: raw.name || "Unnamed User",
        email: raw.email || "",
        role: raw.role || "unknown",
        groupId: raw.groupId || null,
        // Preserve remaining fields (uid, createdAt, etc.)
        ...Object.keys(raw)
          .filter(key => !['name', 'email', 'role', 'groupId'].includes(key))
          .reduce((obj, key) => ({ ...obj, [key]: raw[key] }), {})
      };

      allUsers.push(user);

      if (!user.groupId) {
        if (user.role === "mentor") unassignedMentors.push(user);
        else if (user.role === "learner") unassignedLearners.push(user);
      }
    });

    return { allUsers, unassignedMentors, unassignedLearners };
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const getUsersByRole = (users, role) => {
  if (!role || typeof role !== 'string') return [];
  return users.filter(user => user.role === role);
};

export const getUnassignedUsers = (users) => {
  return users.filter(user => !user.groupId);
};

export const getUsersByGroup = (users, groupId) => {
  if (!groupId) return [];
  return users.filter(user => user.groupId === groupId);
};